var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagFra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2630 2973)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_FRA",
    transform: "translate(-2630 -2973)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_franca",
    transform: "translate(2607.575 2973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_436",
    "data-name": "Ret\\xE2ngulo 436",
    width: 34.284,
    height: 59.996,
    transform: "translate(5.998 0)",
    fill: "#323e95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_437",
    "data-name": "Ret\\xE2ngulo 437",
    width: 24.284,
    height: 59.996,
    transform: "translate(40.284 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_438",
    "data-name": "Ret\\xE2ngulo 438",
    width: 34.282,
    height: 59.996,
    transform: "translate(64.569 0)",
    fill: "#d80031"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFra);
export default __webpack_public_path__ + "static/media/flag_FRA.c3a63dd36a7bdb53979cac252ed16ba1.svg";
export { ForwardRef as ReactComponent };